import React from 'react';
import { artistInfo } from '../data/mock';
import { Play } from 'lucide-react';

const VideoSection = () => {
  return (
    <section id="video" className="py-24 bg-black relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 via-black to-cyan-900/20"></div>
      
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <div className="inline-block mb-4">
            <span className="text-blue-400 text-sm font-medium uppercase tracking-widest border-b-2 border-blue-400 pb-2 flex items-center gap-2">
              <Play size={16} />
              Neueste Single
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">
            Aktuelles
            <span className="block bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent">
              Musikvideo
            </span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Erlebe meine neueste Single in voller Pracht - mit atemberaubenden Bildern und emotionaler Performance.
          </p>
        </div>

        {/* Video Container */}
        <div className="max-w-5xl mx-auto">
          <div className="relative group">
            {/* Glow Effect */}
            <div className="absolute -inset-1 bg-gradient-to-r from-blue-500 via-cyan-400 to-blue-500 rounded-2xl blur-xl opacity-30 group-hover:opacity-50 transition duration-1000 animate-pulse"></div>
            
            {/* Video Wrapper */}
            <div className="relative aspect-video rounded-2xl overflow-hidden shadow-2xl bg-gray-900">
              <iframe
                className="w-full h-full"
                src={`https://www.youtube.com/embed/${artistInfo.youtubeVideoId}`}
                title="Laura Sommerfeld - Neuestes Musikvideo"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          {/* Video Info */}
          <div className="mt-8 text-center">
            <p className="text-gray-400 text-sm">
              Veröffentlicht: Dezember 2024 | Regie: Max Müller | Produktion: Schmidt Productions
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
